// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"db7e9cac","312":"2d8cc6c7","592":"7096e608"}[chunkId] + ".chunk.js";
};